import { render, staticRenderFns } from "./EventParticipationTable.vue?vue&type=template&id=cafed0a6"
import script from "./EventParticipationTable.vue?vue&type=script&lang=js"
export * from "./EventParticipationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports